import React from 'react'
import axios from 'axios'

const BASE_URL =
  'https://6l3r1lznw7.execute-api.us-east-1.amazonaws.com/prod/latercera-newsletters'

const jsonify = input => {
  if (!input) {
    return null
  }
  if (typeof input !== 'string') {
    return input
  }
  return JSON.parse(input)
}

const normalize = input => {
  //I'm so, so sorry about this. I'm not proud of it.
  const output = jsonify(input)
  if (!output) {
    return null
  }
  if (output.isArray && output.length === 0) {
    return null
  }
  return output
}

export const obtainAll = async email => {
  const endpoint = `${BASE_URL}/obtener-secciones`
  try {
    const { data } = await axios.post(endpoint, {
      email,
    })
    const response = normalize(data.body)
    console.log('raw response', response)
    const { newsletters, suscriptor_lt, suscriptor_pc } = response

    return {
      newsletters: normalize(newsletters),
      suscriptor_lt: normalize(suscriptor_lt),
      suscriptor_pc: normalize(suscriptor_pc),
    }
  } catch (err) {
    throw err
  }
}

export const optInThirdParty = async (email, optin) => {
  const endpoint = `${BASE_URL}/administrar-publicidad`
  const { data } = await axios.post(endpoint, {
    email,
    status: `${optin}`,
  })
  return data
}

export const subscribeSection = async (email, newsletter) => {
  const endpoint = `${BASE_URL}/administrar-seccion`
  const { data } = await axios.post(endpoint, {
    newsletter: {
      nombre: newsletter,
      status: 'true',
    },
    email,
  })
  return data
}

export const unsubscribeSection = async (email, newsletter) => {
  const endpoint = `${BASE_URL}/administrar-seccion`
  const { data } = await axios.post(endpoint, {
    newsletter: {
      nombre: newsletter,
      status: 'false',
    },
    email,
  })
  return data
}

export const unsubscribeAll = async email => {
  const endpoint = `${BASE_URL}/desinscribir-secciones`
  const { data } = await axios.post(endpoint, {
    email,
  })
}

export const obtainSubscriptionStatus = async email => {
  const endpoint = `${BASE_URL}/desinscribir-secciones`
  const { data } = await axios.get(endpoint, {
    params: {
      email,
    },
  })
  return data
}
